import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit'
import { getLang } from 'features/users/userApi'

const initialState = {
    languages: [],
    signalr: false,
    zscTab: 'patients',
}

export const getLanguages = createAsyncThunk('app/languages', async (arg, thunkAPI) => {
    try {
        const response = await getLang()
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        connectSignalr: state => {
            state.signalr = true
        },
        setTab: (state, { payload }) => {
            state.zscTab = payload
        },
    },
    extraReducers: builder => {
        builder.addCase(getLanguages.fulfilled, (state, { payload }) => {
            state.languages = payload.data
        })
    },
})

export const { connectSignalr, setTab } = appSlice.actions
export default appSlice.reducer

const app = state => state.app

export const languages = createSelector(app, state => state.languages)

export const mappedLanguages = createSelector(languages, languages => {
    return languages.length
        ? languages.map(language => {
              return {
                  label: language.displayName,
                  value: language.value,
                  id: language.id,
              }
          })
        : null
})
